import { rgba } from 'polished';

import { ColorVars, LIGHT_THEME, type Theme } from '@/utils/theme/themes';

export const FRIENDS_OF_DATA_THEME: Theme = {
  ...LIGHT_THEME,
  backgroundColor: ColorVars.LIGHT_VIOLET_TOPAZ,
  borderColor: {
    MUTED: rgba(ColorVars.VIOLET_TOPAZ, 0.1),
    DEFAULT: rgba(ColorVars.VIOLET_TOPAZ, 0.2),
    LOUD: rgba(ColorVars.VIOLET_TOPAZ, 0.3)
  },
  fontColor: {
    DEFAULT: ColorVars.VIOLET_TOPAZ,
    MUTED: rgba(ColorVars.VIOLET_TOPAZ, 0.6),
    LOUD: '#000'
  },
  fontFamily: {
    ...LIGHT_THEME.fontFamily,
    DISPLAY: 'PP Editorial Old'
  },
  nav: {
    sticky: {
      backgroundColor: ColorVars.LIGHT_VIOLET_TOPAZ
    },
    dropdown: {
      backgroundColor: ColorVars.LIGHTEST_VIOLET_TOPAZ
    }
  },
  footer: {
    divider: {
      color: rgba(ColorVars.VIOLET_TOPAZ, 0.2)
    }
  }
};
